import { Link } from '@inertiajs/react';
import { ActionIcon, Button, Text } from '@mantine/core';

import { useMediaQuery } from '@/hooks/useMediaQuery';

export default function NavButton({
  href,
  label,
  icon,
  activePrefix,
}: {
  href: string;
  label: string;
  icon?: React.ReactNode;
  activePrefix?: string;
}) {
  const currentPath = window.location.pathname;
  const { isMobile } = useMediaQuery();
  const variant = currentPath.startsWith(activePrefix ?? href) ? 'light' : 'subtle';

  if (isMobile && icon) {
    return (
      <ActionIcon
        component={Link}
        href={href}
        aria-label={label}
        variant={variant}
        color='gray'
        size='lg'
        style={{ flexShrink: 0 }}
      >
        {icon}
      </ActionIcon>
    );
  }

  return (
    <Button component={Link} href={href} variant={variant} color='gray' leftSection={icon}>
      <Text component='span' inherit truncate maw={140}>
        {label}
      </Text>
    </Button>
  );
}
